module.exports = __webpack_public_path__ + "static/img/game3.eb36571b.png";